/* Carousel */
const carousels = document.querySelectorAll('[data-carousel="true"]');

carousels.forEach((carousel) => {
  let slides = carousel.dataset.slides;
  let tabletStyle = {
    breakpoint: 767,
    settings: "unslick",
  };

  let mobileStyle = {
    breakpoint: 480,
    settings: "unslick",
  };

  if (carousel.dataset.carouselmobilestyle == "true") {
    tabletStyle = {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.15,
        slidesToScroll: 2,
        dots: true,
        infinite: false,
      },
    };
    mobileStyle = {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        adaptiveHeight: true,
      },
    };
  }

  const settings = {
    infinite: false,
    slidesToShow: 4.15,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.15,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          swipeToSlide: true,
        },
      },
      tabletStyle,
      mobileStyle,
    ],
  };

  if (typeof carousel !== "undefined" && carousel !== null) {
    if (slides >= 4) {
      document.addEventListener("DOMContentLoaded", function () {
        $(carousel).not(".slick-initialized").slick(settings);

        $(window).on("resize orientationchange", function () {
          $(carousel).not(".slick-initialized").slick(settings);
        });

        document.addEventListener("shopify:section:load", function (event) {
          $(carousel).not(".slick-initialized").slick(settings);
        });
      });
    }
  }
});
